export const saveBtnItems = ['CONFIRMED', 'ASSIGNED', 'COMPLETED']
export const transitionStatusItems = {
  DRAFT: ['CONFIRMED', 'ASSIGNED', 'COMPLETED', 'CANCELED', 'DELETE'],
  CONFIRMED: ['ASSIGNED', 'DRAFT', 'COMPLETED', 'CANCELED', 'DELETE'],
  ASSIGNED: ['COMPLETED', 'DRAFT', 'CONFIRMED', 'CANCELED', 'DELETE'],
  COMPLETED: ['DRAFT', 'CONFIRMED', 'ASSIGNED', 'CANCELED', 'DELETE'],
  CANCELED: ['DRAFT', 'CONFIRMED', 'ASSIGNED', 'COMPLETED', 'DELETE'],
}

const statuses = (instance) => {
  return {
    DRAFT: { key: 'DRAFT', label: instance.$t('salesOrder.status.draft'), variant: 'outlineDark' },
    CONFIRMED: { key: 'CONFIRMED', label: instance.$t('salesOrder.status.confirmed'), variant: 'outlineWarning', actionBtnText: instance.$t('salesOrder.action.confirm') },
    ASSIGNED: { key: 'ASSIGNED', label: instance.$t('salesOrder.status.assigned'), variant: 'outlineInfo', actionBtnText: instance.$t('salesOrder.action.assign') },
    COMPLETED: { key: 'COMPLETED', label: instance.$t('salesOrder.status.completed'), variant: 'outlineSuccess', actionBtnText: instance.$t('salesOrder.action.complete') },
    CANCELED: { key: 'CANCELED', label: instance.$t('salesOrder.status.canceled'), variant: 'outlineDanger' },
    DELETE: { key: 'DELETE', label: instance.$t('global.delete') }
  }
}

export const status = {
  DRAFT: 'DRAFT',
  CONFIRMED: 'CONFIRMED',
  ASSIGNED: 'ASSIGNED',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
}

export const successToastMsg = {
  DRAFT: (self) => self.$t('salesOrder.toast.transition.success.draft'),
  CONFIRMED: (self) => self.$t('salesOrder.toast.transition.success.confirmed'),
  ASSIGNED: (self) => self.$t('salesOrder.toast.transition.success.assigned'),
  COMPLETED: (self) => self.$t('salesOrder.toast.transition.success.completed'),
  CANCELED: (self) => self.$t('salesOrder.toast.transition.success.canceled'),
}

export const failedToastMsg = {
  DRAFT: (self) => self.$t('salesOrder.toast.transition.failed.draft'),
  CONFIRMED: (self) => self.$t('salesOrder.toast.transition.failed.confirmed'),
  ASSIGNED: (self) => self.$t('salesOrder.toast.transition.failed.assigned'),
  COMPLETED: (self) => self.$t('salesOrder.toast.transition.failed.completed'),
  CANCELED: (self) => self.$t('salesOrder.toast.transition.failed.canceled'),
}

export default statuses